import React from "react";

import Style from "../../../styles/js/StyleCallList.js";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import * as Constants from "../../../consts/Constants.js";

import Details from './user-details';
import Profile from './user-profile';
import AdditionalRoles from './additional-roles'

import alerter from "../../alerts/alerter"
import service from '../../../plas/user/service.jsx';

function UserForm({ 
  userId,
  onCancel,
  fullWidth
}) {

  const style = Style();
  
  const [user, setUser] = React.useState(null);
  const [roles, setRoles] = React.useState(null);

  const [loadingUser, setLoadingUser] = React.useState(true);
  const [loadingRoles, setLoadingRoles] = React.useState(true);

  React.useEffect(() => {
    loadUser();
    loadRoles();
  }, []);

  const loadUser = () => {
    setLoadingUser(true);
    service.api.users.get(userId, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setUser(response.result);
        setLoadingUser(false);
      }
    });
  }

  const loadRoles = () => {
    setLoadingRoles(true);
    service.api.roles.get(undefined, undefined, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {

        let aux = {}
        aux.list = response.result;
        aux.map = {};
        aux.list.forEach((item) => {
          aux.map[item.id] = item;
          item.label = item.description;
        })
        setRoles(aux);
        setLoadingRoles(false);
      }
    });
  }

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        marginTop: 6,
        marginBottom: 16,
        height: 2
      }}
    />
  );

  return (
    <div className={style.box} >
      { loadingUser || loadingRoles ? (
        <div style={{color:Constants.COLOR_PRIMARY}}>
          <CircularProgress color="inherit" />
        </div>
      ) : (
         <Grid container style={{ paddingBottom: '16px' }}>
              <Grid item xs={false} md={ fullWidth ? false : 2} />
              <Grid item xs={12} md={ fullWidth ? 12 : 8} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <p style={{ fontSize: '28px', textAlign: 'left'}}>
                      Cuenta
                    </p>
                    <ColoredLine color="gray"/>
                  </Grid>
                  <Grid item xs={12} >
                    <Details user={user} roles={roles}/>
                  </Grid>
                  <Grid item xs={12} >
                    <AdditionalRoles user={user} roles={roles} />
                  </Grid>
                </Grid>
                { user.userProfile && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <p style={{ fontSize: '28px', textAlign: 'left', marginTop: '16px'}}>
                          Perfil
                        </p>
                      <ColoredLine color="gray"/>
                    </Grid>
                    <Grid item xs={12} >
                      <Profile user={user} roles={roles}/>
                    </Grid>
                  </Grid>
                )}
                </Grid>
              <Grid item xs={false} md={ fullWidth ? false : 2} />
          </Grid>
      )}
   
    </div>
  );

}


export default UserForm;